import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import './Estatistic.css';

const StatsCounter = () => {
  const [startCounting, setStartCounting] = useState(false);
  
  const statsData = [
    {
      id: 1,
      title: 'Estudantes',
      targetValue: 3500,
      prefix: '',
      suffix: '+',
      description: 'Total de estudantes ativo',
      duration: 2
    },
    {
      id: 2,
      title: 'Docentes',
      targetValue: 450,
      suffix: '+',
      description: 'Número de professores',
      duration: 2
    },
    {
      id: 3,
      title: 'Cursos',
      targetValue: 98,
      prefix: '',
      suffix: '%',
      description: 'Número de cursos de licenciatura',
      duration: 2
    },
    {
      id: 4,
      title: 'Investigação',
      targetValue: 65000,
      prefix: '',
      suffix: '+',
      description: 'Projetos de investigação',
      duration: 2
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setStartCounting(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(document.querySelector('.stats-counter-section'));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-counter-section py-5">
      <Container>
        {/* Título alinhado à esquerda */}
        <div className="text-left mb-5">
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            ISPA em Números
          </motion.h2>
          <motion.div 
            className="title-underline"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
        </div>

        <Row className="g-4">
          {statsData.map((stat) => (
            <Col key={stat.id} xs={12} md={6} lg={3}>
              <motion.div 
                className="stat-counter-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: stat.id * 0.1 }}
              >
                <div className="stat-counter-header">
                  <span className="stat-counter-icon">{stat.icon}</span>
                  <h3 className="stat-counter-title">{stat.title}</h3>
                </div>
                <div className="stat-counter-content">
                  <Counter 
                    target={stat.targetValue} 
                    prefix={stat.prefix}
                    suffix={stat.suffix}
                    duration={stat.duration}
                    start={startCounting}
                  />
                  <p className="stat-counter-description">{stat.description}</p>
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

const Counter = ({ target, prefix = '', suffix = '', duration = 2, start = false }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let startTimestamp;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / (duration * 1000), 1);
      const currentCount = Math.floor(progress * target);
      setCount(currentCount);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [target, duration, start]);

  return (
    <p className="stat-counter-value">
      {prefix}
      {new Intl.NumberFormat().format(count)}
      {suffix}
    </p>
  );
};

export default StatsCounter;